import { Link } from "source/notifications/NotificationShow"
import { Organization } from "../../types"
import { Heading } from "@planningcenter/doxy-web"

export default function DisconnectedNoTFN({
  organization,
}: {
  organization: Organization
}) {
  return (
    <div className="d-f fd-c g-1 py-5 px-2 ta-c c-tint2">
      <div className="d-f jc-c mb-2">
        <img src="/static/mobile-phone.svg" alt="" width="60" />
      </div>

      <Heading
        level={3}
        color="tint2"
        text="Text2Give is no longer supported via 84321"
      />
      <p>You can give to {organization.name} in Church Center.</p>
      <div className="d-f jc-c">
        <Link to="/giving" className="btn outline-btn">
          Give now
        </Link>
      </div>
    </div>
  )
}
